
import { currencyEnum, currencyOptions } from 'pawpaddock-common/data/currency'

import numberMask from '~/lib/input-masks/number'

export default {
  name: 'InputCurrency',

  props: {
    value: {
      type: Number,
      default: null
    },

    currencyCode: {
      type: String,
      default: 'GBP'
    },

    inputClass: {
      type: [String, Array, Object],
      default: 'max-w-[250px]'
    },

    canSelectCurrency: {
      type: Boolean,
      default: false
    },

    suffixNoPadding: {
      type: Boolean,
      default: false
    },

    prefixNoPadding: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      currencyOptions,
      currencyEnum,
      numberMask
    }
  },

  computed: {
    compValue: {
      get() {
        return this.value ? this.value / 100 : null
      },

      set(amount) {
        this.$emit('input', parseFloat((amount * 100).toFixed(2)))
      }
    },

    compCurrencyCode: {
      get() {
        return this.currencyCode
      },

      set(currencyCode) {
        this.$emit('update:currencyCode', currencyCode)
      }
    }
  }
}
